import { palette } from "./ns-color-palette";
import { ColorValueHex, NsTheme, TypedColor } from "./ns-eds-types";
import { isNsPaletteColor } from "./nsPaletteColors";
import { isNsSemanticColor } from "./nsSementicColors";

export function typedColorToString(color: TypedColor, theme: NsTheme): ColorValueHex {
  if (isNsSemanticColor(color)) {
    return theme.colors[color];
  }
  if (isNsPaletteColor(color)) {
    return palette[color];
  }
  return color;
}
